import { render } from "./SectionsMenu.vue?vue&type=template&id=7c466806&scoped=true"
import script from "./SectionsMenu.vue?vue&type=script&lang=js"
export * from "./SectionsMenu.vue?vue&type=script&lang=js"

import "./SectionsMenu.vue?vue&type=style&index=0&id=7c466806&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c466806"]])

export default __exports__